module.exports = __webpack_public_path__ + "media/application/images/svgs/toggle-left-c43516e2e49f3f29592452c61bf036d1.svg";